import { Text as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import t from "./Notification.module.js";
import { c as n } from "react/compiler-runtime";
import { Button as r } from "@jetbrains/ring-ui-built/components/button/button.js";
import i from "classnames";
import { Fragment as a, createElement as o, useState as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import u from "@jetbrains/icons/chevron-20px-down.js";
import d from "@jetbrains/icons/close.js";
//#region src/components/Notification/Notification.tsx
var f = (a) => {
	let o = n(45), f, h, g, _, v, y, b, x, S, C;
	o[0] === a ? (f = o[1], h = o[2], g = o[3], _ = o[4], v = o[5], y = o[6], b = o[7], x = o[8], S = o[9], C = o[10]) : ({className: g, children: h, type: C, title: S, onClose: _, actions: f, collapsible: b, onCollapseChange: v, isCollapsed: x, ...y} = a, o[0] = a, o[1] = f, o[2] = h, o[3] = g, o[4] = _, o[5] = v, o[6] = y, o[7] = b, o[8] = x, o[9] = S, o[10] = C);
	let w = b !== void 0 && b, [T, E] = s(x !== void 0 && x), D;
	o[11] !== T || o[12] !== v ? (D = () => {
		v && v(!T), E(p);
	}, o[11] = T, o[12] = v, o[13] = D) : D = o[13];
	let O = D, k = t[C], A = !h, j;
	o[14] !== g || o[15] !== k || o[16] !== A ? (j = i(t.wrapper, g, k, { [t.inline]: A }), o[14] = g, o[15] = k, o[16] = A, o[17] = j) : j = o[17];
	let M;
	o[18] !== T || o[19] !== S ? (M = S && /* @__PURE__ */ c("header", {
		className: i(t.header, { [t.isCollapsed]: T }),
		children: S
	}), o[18] = T, o[19] = S, o[20] = M) : M = o[20];
	let N;
	o[21] !== w || o[22] !== _ ? (N = _ && !w && /* @__PURE__ */ c(r, {
		"aria-label": "Close",
		onClick: _,
		icon: d
	}), o[21] = w, o[22] = _, o[23] = N) : N = o[23];
	let P;
	o[24] !== M || o[25] !== N ? (P = /* @__PURE__ */ l("div", {
		className: t.titleContainer,
		children: [M, N]
	}), o[24] = M, o[25] = N, o[26] = P) : P = o[26];
	let F;
	o[27] !== h || o[28] !== T ? (F = !T && /* @__PURE__ */ c("div", { children: h }), o[27] = h, o[28] = T, o[29] = F) : F = o[29];
	let I;
	o[30] !== w || o[31] !== O || o[32] !== T ? (I = w && /* @__PURE__ */ c(r, {
		"aria-label": T ? "Expand" : "Collapse",
		className: i({ [t.isCollapsed]: T }),
		onClick: O,
		icon: u,
		iconClassName: t.chevronIcon
	}), o[30] = w, o[31] = O, o[32] = T, o[33] = I) : I = o[33];
	let L;
	o[34] !== I || o[35] !== P || o[36] !== F ? (L = /* @__PURE__ */ l(e, {
		as: "div",
		className: t.container,
		children: [
			P,
			F,
			I
		]
	}), o[34] = I, o[35] = P, o[36] = F, o[37] = L) : L = o[37];
	let R;
	o[38] === f ? R = o[39] : (R = f && /* @__PURE__ */ c("div", {
		className: t.actions,
		children: f.map(m)
	}), o[38] = f, o[39] = R);
	let z;
	return o[40] !== y || o[41] !== L || o[42] !== R || o[43] !== j ? (z = /* @__PURE__ */ l("div", {
		className: j,
		...y,
		children: [L, R]
	}), o[40] = y, o[41] = L, o[42] = R, o[43] = j, o[44] = z) : z = o[44], z;
};
function p(e) {
	return !e;
}
function m(e) {
	if ("custom" in e) return /* @__PURE__ */ c(a, { children: e.custom }, e.key);
	let { children: t, key: n, ...i } = e;
	return /* @__PURE__ */ o(r, {
		...i,
		key: n,
		"data-test": n
	}, t);
}
//#endregion
export { f as Notification };
